<template>
    <div class="row drag-and-drop-file-upload" :class="{'multiple': multiple}">
        <div class="col s12" style="width: 100% in !important;">
            <input 
                type="file" 
                hidden 
                ref="file" 
                :multiple="multiple"
                @change="onChange"
                :accept="accept"
                :disabled="disabled"
            />
            <div 
                v-if="filelist && filelist.length"
                class="file-path-wrapper secondary-color-text upload"
                :style="`height: ${heightComponent};`"
                @dragover="dragover" 
                @dragleave="dragleave" 
                @drop="drop"
            >   
                <template v-if="multiple">
                    <a  
                        class="waves-effect waves-light btn btn-flat col hide-on-small-only" 
                        :class="{'s6': !disableRemoverTodos, 's12': disableRemoverTodos}"
                        @click="chooseFiles"
                    >
                        <div class="secondary-color-text valign-wrapper">
                            <i class="material-icons mr-1">note_add</i>
                            <span>{{ divOverflowWidth > 600 ? msgDragAndDrop : 'adicionar mais' }}</span>
                        </div>
                    </a>
                    <a  
                        class="waves-effect waves-light btn btn-flat col s5 hide-on-med-and-up" 
                        @click="chooseFiles"
                    >
                        <div class="secondary-color-text valign-wrapper">
                            <i class="material-icons mr-1">note_add</i>
                            <span>add</span>
                        </div>
                    </a>
                    <a 
                        v-if="!disableRemoverTodos"
                        class="waves-effect waves-light btn btn-flat col s7 m6"
                        @click="removeFiles"
                    >
                        <div class="secondary-color-text valign-wrapper right">
                            <span class="mr-1">remover todos</span>
                            <i class="material-icons">delete</i>
                        </div>
                    </a>
                </template>
                <div 
                    ref="divOverflow" 
                    class="col s12 divOverflow grey lighten-4" 
                    :style="`padding: .5rem;${divOverflowWidth < 600 ? 'padding: 0.5rem;display: flex;align-items: center;' : ''}`"
                >
                    <div 
                        class="col s12" 
                        :class="{'m6': divOverflowWidth > 600, 'm4': divOverflowWidth > 750}"
                        v-for="(file, index) in filelist" 
                        :key="index" 
                        style="padding: .5rem;"
                    >
                        <div 
                            class="card valign-wrapper col s12 ma-0"
                            :class="{
                                'red lighten-4': !extValida(file) || nomeArquivosInvalidos && nomeArquivosInvalidos.length > 0,
                                'tooltipped': !extValida(file) && getTooltip(file) != '',
                            }"
                            :data-tooltip="getTooltip(file)"
                        >   
                            <div class="col s12 container-file" style="flex-direction: row;">
                                <div class="div-img col s2 m6 pa-0" v-if="varificaImg(file)">
                                    <img :src="preview(file)" />
                                </div>
                                <div class="no-img col s2 pa-0 m6" v-else>
                                    <span class="card-title secondary-color-text secondary-color picker__footer lighten-4 col pa-1 s12">
                                        <i class="material-icons center-block" v-if="preview(file).includes('pdf')">picture_as_pdf</i>
                                        <i 
                                            v-else-if="preview(file).includes('json')"
                                            class="material-icons center-block secondary-color secondary-color-better-text" 
                                            style="border-radius: 52px;border: 1px solid;padding: 4px;">settings_ethernet
                                        </i>
                                        <i 
                                            v-else-if="preview(file).includes('xml')"
                                            class="material-icons center-block secondary-color secondary-color-better-text" 
                                            style="border-radius: 52px;border: 1px solid;padding: 4px;">code
                                        </i>
                                        <template v-else-if="preview(file).includes('xls' && 'xlsx')">
                                            <span 
                                                class="center-block mr-0 white-text" 
                                                style="position: relative;left: 12px;z-index: 10;font-size: 1.2rem;font-weight: 500;">x
                                            </span>
                                            <i 
                                                class="material-icons center-block ml-0" 
                                                style="position: relative;right: 4px;">
                                                insert_drive_file
                                            </i>
                                        </template>
                                        <template v-else>
                                            <i class="material-icons center-block">insert_drive_file</i> 
                                        </template>
                                    </span>
                                </div>
                                <div class="col s10 div-info">
                                    <div class="col s10 file-loaded pl-1 pr-1">
                                        <span 
                                            class="col s12 left-align file-name truncate truncate truncateActive pa-0"
                                            :data-tooltip="file.name">
                                            {{ file.name }}
                                        </span>
                                    </div>
                                    <div class="col s2 icon-remove">
                                        <i 
                                            class="secondary-color-text material-icons btn-flat right"
                                            :class="!disabled && 'hoverable'"
                                            @click="remove(filelist.indexOf(file))">
                                            clear
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="
                    secondary-color-text 
                    secondary-color
                    valign-wrapper
                    cursor_grab 
                    lighten-5 
                    upload 
                " 
                :class="!disabled && 'hoverable'"
                :style="`height: ${heightComponent};`"
                @click="chooseFiles"
                @dragover="dragover" 
                @dragleave="dragleave" 
                @drop="drop"
            >
                <span class="col s12">
                    <span class="col s12">{{ msgAnexarDocs }}</span>
                    <i class="large material-icons">cloud_upload</i>
                    <span class="col s12">{{ msgDragAndDrop }}: ({{ tiposPermitidos.toString().replaceAll(',', ', ') || '*.*' }})</span>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import StHelper from '../../helpers/StHelper';

export default {
    name: 'drag-and-drop-file-upload',
    props: {
        msgAnexarDocs:{ type:String, default: 'Documentos' },
        msgDragAndDrop:{ type:String, default: 'Clique ou arraste e solte aqui' },
        height:{ type:String, default: '12rem' },
        accept:{ type:String, default: '' },
        tiposPermitidos:{ type:Array, default: () => [] },
        multiple:{ type:Boolean, default: false },
        validarNomeArquivo:{ type:Boolean, default: false },
        nomeArquivosInvalidos:{ type:Array, default: () => [] },
        disableRemoverTodos:{ type:Boolean, default: false },
        disabled:{ type:Boolean, default: false },
        tamanhoMaximo: { type: Number, default: 0 },
    },
    data () {
        return {
            filelist: [],
            heightComponent: null,
            divOverflowWidth: null,
        }
    },
    computed: {
        extPermitida: function () {
            const listaExtPermitidas = this.filelist.map(file => {
                const tipoArquivo = file.name.split('.').splice(-1,1)[0].toLowerCase();
                const extPermitida = this.tiposPermitidos.map(x => x.toLowerCase()).includes(tipoArquivo) && tipoArquivo.length > 0;
                return extPermitida;
            });

            // verifica se existe algum resultado falso 
            // e retorna a negação do mesmo para ficar coerente ao nome da variável (extPermitida)
            return listaExtPermitidas && listaExtPermitidas.length > 0 &&  !listaExtPermitidas.includes(false);
		},
    },
    watch: {
        filelist: function(newValue) {
            if(newValue == null || newValue.length == 0) {
                this.removeFile();
                if(!this.multiple && !this.height) this.defineHeight('10rem');
            }
        },
        height: function(newValue) {
            if(newValue) this.defineHeight(newValue);
        },
    },
    created() {
        this.heightComponent = this.height;
        if(!this.multiple && !this.height) this.defineHeight('10rem');
        window.addEventListener("resize", this.resize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resize);
	},
    updated() {
        $(".tooltipped").tooltip({ delay: 50 });
        StHelper.truncateActive();
        this.resize();
    },
    mounted() {
        $(".tooltipped").tooltip({ delay: 50 });
	},
    methods: {
        chooseFiles() {
            this.$refs.file.click();
        },        
        removeFiles(){
            this.filelist = [];
            this.$emit('onFileRemoved', this.filelist);
        },
        onChange() {
            if(this.tamanhoMaximo > 0) {
              const tamanhoMaximo = this.tamanhoMaximo * 1024 * 1024;

              // Verifica se algum arquivo excede o tamanho máximo
              const arquivosInvalidos = Array.from(this.$refs.file.files).filter(file => file.size > tamanhoMaximo);

              if (arquivosInvalidos.length > 0) {
                const plural = arquivosInvalidos.length > 1;
                const S = plural ? 's' : '';
                const M = plural ? 'm' : '';
                const ES = plural ? 'es' : '';
                StHelper.toastAlertaNegative(`O${S} arquivo${S} não pode${M} ser maior${ES} que ${this.tamanhoMaximo}MB: ${arquivosInvalidos.map(file => file.name).join(', ')}`, 8000);
                this.removeFiles();
                return;
              }
            }

            this.filelist.push(...this.removeRepetidos(this.$refs.file.files));

            if(!this.multiple && !this.height) this.defineHeight('5.5rem');
            this.filelist.removeFiles = this.removeFiles;
            console.log('📃 ' + this.filelist.length + ' arquivo(s) selecionado(s)');
            this.$emit('files', this.filelist);
        },
        remove(i) {
            this.filelist.splice(i, 1);
            this.$emit('remove', this.filelist);
        },
        dragover(event) {
            event.preventDefault();
        },
        dragleave(event) {
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange();
            this.dragleave(event);
        },
        varificaImg(file) {
            const type_preview = 'bmp, gif, png, jpg, jpeg, jfif'.toLowerCase();
            const tipoArquivo = file.name.split('.').splice(-1,1)[0].toLowerCase();
            const imgValida = type_preview.includes(tipoArquivo) && tipoArquivo.length > 0;
            return imgValida ? true : false;
        },
        preview(file) {
            if(this.varificaImg(file)) return URL.createObjectURL(file);
            return file.name.split('.').splice(-1,1)[0];
        },
        extValida(file) {
            const tipoArquivo = file.name.split('.').splice(-1,1)[0].toLowerCase();
            const arquivoValido = this.tiposPermitidos.map(x => x.toLowerCase()).includes(tipoArquivo) && tipoArquivo.length > 0;
            return arquivoValido;
        },
        removeFile() {
            this.$refs.file.value = null;
        },
        defineHeight(height) {
            if(height) this.heightComponent = height;
        },

        removeRepetidos(newfiles) {
            let result = newfiles;
            const newfilelist = [];

            for (let i = 0; i < newfiles.length; i++) {
                const newfile = newfiles[i];
                if(this.filelist && this.filelist.length > 0) {
                    const fileRepetido = this.filelist.filter(file => file.name === newfile.name);
                    if(!fileRepetido || fileRepetido && !fileRepetido.length > 0) newfilelist.push(newfile);

                    result = newfilelist;
                }
            }

            return result;
        },
        resize() {
            this.divOverflowWidth = this.$refs.divOverflow && this.$refs.divOverflow.offsetWidth
        },
        atualizarArquivo(novoArquivo) {
            this.filelist = [novoArquivo];
            this.$nextTick(() => $(".tooltipped").tooltip({ delay: 50 }));
        },
        getTooltip(file) {
            const erro = this.nomeArquivosInvalidos && this.nomeArquivosInvalidos.find(f => f[file.name]);
            
            console.log('🟢 nomeArquivosInvalidos:', this.nomeArquivosInvalidos);
            console.log('🟢 erro:', erro);
            
            return erro ? Object.values(erro)[0] : '';
        },
    }
}

</script>

<style lang="scss" scoped>   
    [v-cloak] {
        display: none;
    }

    .drag-and-drop-file-upload {
        margin: 0;
        & > div {
            height: 100%;
            margin: 0;
            padding: 0;

            .upload {
                border: 3px dotted;
                text-align: center;
                border-radius: 8px;
        
                .divOverflow {
                    overflow-y: auto;
                    overflow-x: hidden;
                    height: 100%;
                    padding-top: 0.4rem;
                    padding: 1rem;
                    padding: 0;

                    .card.valign-wrapper {
                        height: 100%;
                        margin: 0;
                        padding: 0;

                        .container-file {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            flex-wrap: nowrap;
                            flex-direction: column;
                            padding: 1rem;
                            height: 94px;

                            .div-img {
                                border-radius: 6px;
                                height: 100%;
                                
                                img {
                                    border-radius: 6px;
                                    max-height: 264px;
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                
                            .no-img {
                                border-radius: 6px;
                                padding: 0;
                                flex-grow: 1;
                                padding-bottom: 1rem;
                
                                .picker__footer {
                                    height: 100%;
                                    position: relative;
                                    border-radius: 6px;
                                }
                            }

                            .div-info{
                                padding: 0;

                                .file-loaded {
                                    padding: 0;
                                    line-height: 30px;

                                    .file-name {
                                        border-bottom: 1px solid;
                                    }
                                }
                
                                .icon-remove {
                                    i {
                                        border-radius: 26px;
                                        position: relative;
                                        line-height: 1.5;
                                        padding: 0 6px;
                                        bottom: 3px;
                                        left: 11px;
                                        top: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .cursor_grab {
                cursor: -webkit-grab;
            }
        }
    
        &.multiple{
            & > div {
                .upload {
                    .divOverflow {
                        padding: 0 1rem;
                        height: calc(100% - 36px);

                        .card.valign-wrapper {
                            margin: 0.5rem 0 1rem 0;
                            height: auto;

                            .container-file {
                                flex-direction: row;
                                
                                .div-img {
                                    width: 40%;
                                    background: white;
                                    height: 100%;
                                  
                                    img {
                                        border-radius: 6px;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }


    @media only screen and (max-width: 600px) {

        .drag-and-drop-file-upload {
            & > div {
                padding: 0;

                .upload {
                    display: flex;
                    
                    .divOverflow {
                        .card.valign-wrapper {
                            .container-file {
                                .div-img {
                                    img {
                                        max-height: 142px;
                                    }
                                }
                    
                                .no-img {
                                    .div-info{
                                        .file-loaded {
                                            top: 0;
                                            transform: none;
    
                                            .file-name {
                                                margin: 0;
                                                margin-top: 1rem;
                                            }
                                        }
                                        .icon-remove {
                                            margin-top: .5rem;
                                            top: 0;
                                            transform: none;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        
            &.multiple{
                & > div {
                    .upload {
                        .divOverflow {
                            .card.valign-wrapper {
                                height: auto;
                                padding: 1rem;

                                .container-file {
                                    flex-direction: column;
                                    padding: 0;

                                    .div-img {
                                        width: 100%;
                                        padding: 0;

                                        img {
                                            padding: 0;
                                        }
                                    }

                                    .no-img {
                                        width: 100%;
                                        padding: 0;

                                        .picker__footer {

                                        }

                                    }

                                    .div-info{
                                        display: flex;
                                        align-items: center;
                                        width: 100%;

                                        .file-loaded {

                                            .file-name {
                                                width: 100%;
                                            }

                                            .msg-error {
                                                width: 100%;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
  
</style> 


// WEBPACK FOOTER //
// DragAndDropFileUpload.vue?6adf18af